import type {
  CertificateDocument,
  CertificatePreview,
  CertificateRequest,
  CertificateTemplate,
} from '../model/types';

export const certificateTemplates: CertificateTemplate[] = [
  {
    certificateType: 'EMPLOYMENT',
    version: 1,
    displayName: '재직증명서',
    statement: '위와 같이 재직 중임을 확인합니다.',
    requireSeal: true,
    autoIssue: true,
    validityDays: 90,
    verificationPublic: true,
    enabled: true,
    publishedAt: '2026-08-23T09:00:00Z',
  },
  {
    certificateType: 'CAREER',
    version: 1,
    displayName: '경력증명서',
    statement: '위 사람의 당사 재직 경력을 아래와 같이 증명합니다.',
    requireSeal: true,
    autoIssue: true,
    validityDays: 90,
    verificationPublic: true,
    enabled: true,
    publishedAt: '2026-08-23T09:00:00Z',
  },
];

export const certificatePreview: CertificatePreview = {
  template: certificateTemplates[0],
  snapshot: {
    legalName: '김민서',
    maskedRegistrationNumber: '920315-*******',
    workerCategory: '임직원',
    workerNumber: 'A260014',
    companyId: 'company-hangyeol',
    companyLegalProfileId: 'company-legal-profile-hangyeol-v1',
    companyLegalProfileVersion: 1,
    companyName: '주식회사 한결',
    registeredAddress: '서울특별시 성동구 왕십리로 83-21, 4층(성수동1가)',
    representativeTitle: '대표이사',
    representativeName: '박재욱',
    sealConfigured: true,
    organizationName: 'Platform Engineering',
    businessTitle: 'Backend Engineer',
    hireDate: '2024-03-04',
    workerStatus: 'ACTIVE',
    issuedOn: '2026-08-25',
  },
};

export const certificateRequests: CertificateRequest[] = [
  {
    id: 'certificate-request-1',
    certificateType: 'EMPLOYMENT',
    displayName: '재직증명서',
    purposeCode: 'FINANCIAL_INSTITUTION',
    destination: '소카은행',
    requesterName: '김민서',
    status: 'ISSUED',
    requestedAt: '2026-08-22T09:14:00Z',
    completedAt: '2026-08-22T09:14:02Z',
    issuance: {
      id: 'issuance-1',
      issuanceNumber: 'HD-20260822-A91F82C61D03',
      documentId: 'my-doc-3',
      status: 'VALID',
      issuedAt: '2026-08-22T09:14:02Z',
      expiresAt: '2026-11-20T09:14:02Z',
    },
  },
];

export const certificateDocuments: CertificateDocument[] = [
  {
    id: 'my-doc-1',
    subjectType: 'WORKER',
    subjectId: '03',
    documentType: 'EMPLOYMENT_CONTRACT',
    displayName: '근로계약서.pdf',
    contentType: 'application/pdf',
    sizeBytes: 182400,
    sha256: 'fixture',
    scanStatus: 'CLEAN',
    createdAt: '2026-01-02T09:00:00Z',
  },
  {
    id: 'my-doc-2',
    subjectType: 'PERSON',
    subjectId: 'person-fixture',
    documentType: 'WITHHOLDING',
    displayName: '2025 근로소득 원천징수영수증.pdf',
    contentType: 'application/pdf',
    sizeBytes: 96400,
    sha256: 'fixture',
    scanStatus: 'CLEAN',
    createdAt: '2026-02-14T09:00:00Z',
  },
];
